import axios from "axios";
import React, { useState } from "react";
import "./userform.css";
import BlueButton from "./BlueButton";
import { toast } from "sonner";
import { LabelInput, LabelTextarea } from "./Inputs";
import { isValidEmail, isBlockedDomain } from "../utility/emailAuthorizations";

// constants
const formFields = [
  {
    type: "text",
    label: "Your name",
    placeholder: "John Doe",
    name: "user_name",
  },
  {
    type: "tel",
    label: "Your mobile no.",
    placeholder: "9800000021",
    maxLength: 10,
    name: "mobile",
  },
  {
    type: "text",
    label: "Your company",
    placeholder: "ABC Industries",
    name: "user_org",
  },
  {
    type: "email",
    label: "Business email",
    placeholder: "john@company.com",
    name: "user_business_email",
  },
  {
    type: "textarea",
    label: "Your enquiry",
    placeholder: "Enter additional details",
    name: "enquiry_text",
    textareaStyle: { height: "100px" },
  },
];

function UserForm({ userApplied }) {
  const [userDetails, setUserDetails] = useState({
    user_name: "",
    user_org: "",
    user_business_email: "",
    enquiry_text: "",
    mobile: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserDetails({ ...userDetails, [name]: value });
  };
  const postData = async (event) => {
    event.preventDefault();
    const {
      user_name,
      user_org,
      user_business_email,
      enquiry_text,
      mobile,
    } = userDetails;

    if (!checkMobileNumber(mobile)) {
      toast.error("Please enter a valid mobile number");
      return;
    }

    if (!user_name.trim()) {
      toast.error("Please enter your name");
      return;
    }

    if (!user_org.trim()) {
      toast.error("Please enter your company name");
      return;
    }

    if (
      isValidEmail(user_business_email) ||
      isBlockedDomain(user_business_email)
    ) {
      toast.error(
        isValidEmail(user_business_email)
          ? "Invalid email address"
          : "Please enter a valid business email address"
      );
      return;
    }

    if (!enquiry_text.trim()) {
      toast.error("Please enter a valid enquiry");
      return;
    }
    setLoading(true);
    try {
      const url = process.env.REACT_APP_BASE_URL;
      const headers = {
        "Content-Type": "application/json",
      };
      const response = await axios.post(url, userDetails, { headers });
      toast.success("Thanks for reaching out! We'll get back to you soon.");
      sessionStorage.setItem("user_registered", true);
      userApplied(true);
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };
  const checkMobileNumber = (mobileno) => {
    if (!/^[6-9]\d{9}$/.test(mobileno)) {
      setUserDetails((prev) => ({ ...prev, mobile: "" }));
      return false;
    }
    return true;
  };

  return (
    <div className="userform-wrapper" id="book-a-demo">
      <div className="userform-headings">
        <span className="userform-mainheading">See BeFiSc in Action</span>
        <span className="userform-subheading">
          Schedule a personalized demo to discover how our solutions can benefit
          your business
        </span>
      </div>
      <form
        onSubmit={postData}
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ width: "100%" }}>
          {formFields.map((field, index) =>
            field.type === "textarea" ? (
              <LabelTextarea
                key={index}
                label={field.label}
                placeholder={field.placeholder}
                value={userDetails[field.name]}
                name={field.name}
                onChange={handleChange}
                textareaStyle={field.textareaStyle}
              />
            ) : (
              <LabelInput
                key={index}
                type={field.type}
                label={field.label}
                placeholder={field.placeholder}
                value={userDetails[field.name]}
                name={field.name}
                maxLength={field.maxLength}
                onChange={handleChange}
              />
            )
          )}
        </div>
        <div className="form-btn">
          <BlueButton
            styles={{ width: "100%" }}
            text={!loading ? "Request a Demo Now" : "wait..."}
            type="submit"
          />
        </div>
      </form>
    </div>
  );
}

export default UserForm;
